<template>
 
  <div v-if="this.$waveui.breakpoint.sm || this.$waveui.breakpoint.xs" class="d-flex align-items-center justify-content-center img-wrap "  >
  <img 
        class="canvas img-fluid"
  src="@/assets/home.jpg"/>
</div>
<div v-else class="d-flex align-center justify-center center img-wrap ">
<!-- <w-image
  class="canvas-big img-fluid"
  :ratio="windowHeight / windowWidth"
  transition="slide-fade-down"
  src="img/home.jpg"/> -->
  <img src="@/assets/home.jpg" class="canvas-big  img-fluid" :height="windowHeight" :width="windowWidth" />
</div>
  
</template>

<script>
import { store } from "@/utils/store";
import { useWindowSize } from 'vue-window-size';

export default {
data() {

  return {
    windowWidth: useWindowSize().width,
    windowHeight: useWindowSize().height,
    store,
  };
},

};
</script>

<style scoped>
.canvas {
max-width: 100%; /* Larghezza massima pari alla larghezza del contenitore */
height: auto; /* Altezza automatica in base alla larghezza */
object-fit: cover; /* Taglia l'immagine per coprire completamente l'elemento */
}
.canvas-big {
position: relative;/* Larghezza massima pari alla larghezza del contenitore */
min-height: 100%; /* Altezza automatica in base alla larghezza */
object-fit: cover; /* Taglia l'immagine per coprire completamente l'elemento */
}
.img-wrap {
min-height: 70vh; /* Altezza minima pari alla viewport height */
}
</style>
